//
// THIS MODULE WILL ENABLE LANGUAGE SELECTOR
//
// Make sure you have following div in your code:
// <div id="LanguageSelector"></div>
// and
// call setLanguages function inside init function

export default class LanguageSelector implements IDigitalIdentityHubModule {
  public name = "LanguageSelector";
  static moduleName = "LanguageSelector";

  private languageSelector: HTMLElement;
  private defaultLanguage = "en-US";
  private languages: ILanguages = {
    "en-US": "English"
  };
  private currentLanguage = "en-US";

  public setLanguages = (defaultLanguage: string, mapping: ILanguages) => {
    this.languages = mapping;

    this.defaultLanguage = defaultLanguage ? defaultLanguage : Object.keys(this.languages)[0];
    this.currentLanguage = this.getLanguage(this.defaultLanguage);

    if (this.languages) {
      const languagesKeys = Object.keys(this.languages);
      if (languagesKeys.indexOf(this.currentLanguage) === -1) {
        this.currentLanguage = languagesKeys[0];

        this.setLanguage(this.currentLanguage);
      }
    }

    janrain.settings.language = this.currentLanguage;
  };

  public getLanguage(defaultLanguage: string) {
    let desiredLanguage = window.DigitalIdentityHub.utilities.getCookie("language");

    if (!desiredLanguage) {
      desiredLanguage = localStorage.getItem("DigitalIdentityHub-language");
    }

    if (!desiredLanguage) {
      return defaultLanguage;
    }
    return desiredLanguage;
  }

  public init(): void {
    janrain.settings.language = this.currentLanguage;
  }

  public ready(): void {
    if (this.currentLanguage === "he-IL") {
      const bodyElement = document.getElementsByTagName("body")[0];
      console.log("bodyElement", bodyElement);
      bodyElement.className = bodyElement.className ? `${bodyElement.className} rtl` : "rtl";
    }
    this.translate();

    this.languageSelector = document.getElementById("LanguageSelector");
    const languagesArray = Object.keys(this.languages);

    if (this.languageSelector && languagesArray.length > 1) {
      this.languageSelector.className = "LanguageSelector";
      const optionsWrapper = document.createElement("div");
      optionsWrapper.className = "LanguageSelector__options";

      this.languageSelector.appendChild(optionsWrapper);

      languagesArray.forEach(key => {
        if (key === this.currentLanguage) {
          const languageItem = document.createElement("div");
          languageItem.className = "LanguageSelector__current";
          languageItem.innerText = this.languages[key];
          this.languageSelector.appendChild(languageItem);
        } else {
          const languageItem = document.createElement("div");
          languageItem.innerText = this.languages[key];
          languageItem.setAttribute("data-value", key);
          optionsWrapper.appendChild(languageItem);
        }
      });
      optionsWrapper.addEventListener("click", this.optionClicked);

      const languageSelectorCurrent = this.languageSelector.querySelector(".LanguageSelector__current");

      if (languageSelectorCurrent) {
        languageSelectorCurrent.addEventListener("click", this.toggleLanguageSelector);
      }
      document.addEventListener("click", this.hideLanguageSelector);
    } else {
      return;
    }
  }

  private setLanguage = (requestedLanguage: string) => {
    janrain.settings.language = requestedLanguage;

    document.cookie = "language=" + requestedLanguage + "; path=/";
    localStorage.setItem("DigitalIdentityHub-language", requestedLanguage);
  };

  private translate = () => {
    const translations = window.DigitalIdentityHub.translations[this.currentLanguage];

    if (translations) {
      Array.from(document.querySelectorAll("[data-translate-content]")).forEach(i => {
        if (i instanceof HTMLElement && translations[i.innerText.trim()]) {
          i.innerHTML = translations[i.innerText.trim()];
        } else if (i instanceof HTMLElement) {
          translations[i.innerText.trim()] = i.innerHTML;
        }
      });
      Array.from(document.querySelectorAll("[data-translate-value]")).forEach(i => {
        if (i instanceof HTMLInputElement && translations[i.value.trim()]) {
          i.value = translations[i.value.trim()];
        } else if (i instanceof HTMLInputElement) {
          translations[i.value.trim()] = i.value.trim();
        }
      });
      Array.from(document.querySelectorAll("[data-translate-placeholder]")).forEach(i => {
        if (i instanceof HTMLInputElement && translations[i.placeholder.trim()]) {
          i.placeholder = translations[i.placeholder.trim()];
        } else if (i instanceof HTMLInputElement) {
          translations[i.placeholder.trim()] = i.placeholder.trim();
        }
      });
    }
  };

  private optionClicked = e => {
    const option = e.target;
    this.currentLanguage = option.dataset.value;
    this.setLanguage(this.currentLanguage);
    window.location.reload();
  };

  private toggleLanguageSelector = e => {
    const selector = e.target.parentNode;
    const isOpenned = selector.className.includes("active");

    this.languageSelector.className = isOpenned ? "LanguageSelector" : "LanguageSelector LanguageSelector--active";
  };

  private hideLanguageSelector = e => {
    const isClickInside = this.languageSelector.contains(e.target);

    if (!isClickInside) {
      this.languageSelector.className = "LanguageSelector";
    }
  };
}
